const BYTES_PER_UNIT = 1024;
const SIZE_UNITS = ['B', 'KB', 'MB', 'GB'];

/**
 * Human-readable byte size (`512 B` / `4.0 KB` / `1.2 MB` / `3.0 GB`). Whole
 * bytes are printed as-is; every larger unit gets one decimal.
 */
export default function formatBytes(bytes: number): string {
  let value = bytes;
  let unitIndex = 0;
  while (value >= BYTES_PER_UNIT && unitIndex < SIZE_UNITS.length - 1) {
    value /= BYTES_PER_UNIT;
    unitIndex += 1;
  }
  const rendered = unitIndex === 0 ? String(value) : value.toFixed(1);
  return `${rendered} ${SIZE_UNITS[unitIndex]}`;
}
